@if (Settings.isInAny(['Admin', 'BackOffice'], true) && Settings.getUser().MayImpersonate && Settings.getUser().Impersonating) {
  <mat-form-field appearance="outline" style="max-width: 400px;">
    <mat-label>{{ 'Turbo.GroupFilter.Component.lblRentalLocationGroup' | translate:'Rental location group' }}</mat-label>
    <mat-select [(ngModel)]="rentalLocationGroup" (ngModelChange)="onGroupChange($event)" panelClass="rental-group-panel" (openedChange)="resetSearch($event)">
      <div class="search-container" style="position: sticky; top: 0; z-index: 1; background: white; width: 100%; padding-top: 2px;">
        <mat-form-field appearance="outline" style="width: 100%;">
          <input matInput [(ngModel)]="searchText" (keyup)="filterGroups()" placeholder="{{ 'Turbo.GroupFilter.Component.lblSearchGroupType' | translate:'Type to search...' }}"
                 (click)="$event.stopPropagation()" />
        </mat-form-field>
      </div>
      <mat-option [value]="0">{{ 'Turbo.GroupFilter.Component.lblNoFilter' | translate : 'None' }}</mat-option>
      <mat-option *ngFor="let group of filteredGroups" [value]="group.Id">{{ group.Name }}</mat-option>
    </mat-select>
  </mat-form-field>
}
